import React from 'react'

import './Typo.scss'

const Hometypo = () => {

   
    

    return (

        
        <div className="tyno" >
            <h1 className="typoHead"> Actions speaks</h1>
            <div className="hidden">   Priority</div>

            <div className="image_gsap"></div>
            
        </div>
    )
}

export default Hometypo;
